const BLOCK_TYPE_TO_I18N: Record<string, string> = {
  big_banner: 'block_large_banner',
  gallery: 'block_gallery',
  text_with_heading: 'block_text_with_heading',
  list_with_heading_text: 'block_list_with_heading',
  text: 'block_text',
  button: 'block_button',
  product_slider: 'block_product_slider',
  category_gallery: 'block_category_gallery',
};

export function contentBlockTypeLabelKey(type: string): string {
  return BLOCK_TYPE_TO_I18N[type] ?? `block_type_${type}`;
}

const FIELD_KEY_TO_I18N: Record<string, string> = {
  alt: 'field_alt',
  image: 'field_image',
  link: 'field_link_optional',
  button: 'field_button_optional',
  text: 'field_text',
  heading: 'field_heading',
  header: 'field_heading',
  items: 'field_list_items',
  color: 'field_color_optional',
  uuids: 'field_skus',
  skus: 'field_skus',
  category_ids: 'field_category_ids',
};

export function fieldPropertyLabelKey(propKey: string): string {
  return FIELD_KEY_TO_I18N[propKey] ?? `field_prop_${propKey}`;
}
